import { dateFormatMap } from '@op/constants';
import { formatTime } from '../../render-helper';

export default function (params: any) {
  const { dateType } = params;
  return [
    {
      renderHelper: [formatTime(dateFormatMap[dateType])],
      header: 'Date',
      render: 'time',
    },
    { header: 'Name', render: 'name' },
    { header: 'Reviews', render: 'count' },
  ];
}
